<template>
    <div style="background-color: #ccc" id="question-wrapper">
        <SingleQuestionEditor
            v-for="(question, index) in payload"
            v-model="payload[index]"
            :on-removed="onQuestionRemoved"
            :key="question.id"
            :show-next-question-action="index !== payload.length - 1"
            :startDrag="startDrag"
            :onDrop="onDrop"
            :index="index"
            :payload="payload"
        />
        <div class="add-single-question-wrapper filter-add-group-wrapper">
            <div class="add-single-question">
                <div class="add-single-question-plus" @click="addNewQuestion">
                    <span class="material-icons"> add </span>
                </div>
                <span class="text">{{ $t("chatbotv2.addNextQuestion") }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import SingleQuestionEditor from "./question/SingleQuestionEditor";
import _ from "lodash";
import { generateRandomId } from "../../../../../../utils/session";
import log2 from "../../../../../../utils/log2";

const log = log2("Question");
export default {
    name: "Question",
    components: { SingleQuestionEditor },
    props: ["value", "Payloads"],
    data() {
        return {
            payload: this.value,
        };
    },
    methods: {
        onQuestionRemoved(id) {
            let questions = this.payload.filter((question) => question.id !== id);
            if (questions.length > 0 && _.last(questions).onFailure === "go_to_next_question") {
                _.last(questions).onFailure = "go_to_failure";
            }
            this.payload = questions;
        },
        addNewQuestion() {
            const question = _.cloneDeep(this.Payloads.QUESTION.default[0]);
            question.id = generateRandomId();
            let questions = _.cloneDeep(this.payload);
            if (questions.length > 0) {
                questions[questions.length - 1].onFailure = "go_to_next_question";
            }
            questions = [...questions, question];
            this.payload = questions;
        },
        startDrag(evt, draggedPointIndex) {
            log(
                "payload before DAD",
                this.payload.map((x) => x.id)
            );
            log("DAD dragg point", this.payload[draggedPointIndex].id);
            evt.dataTransfer.dropEffect = "move";
            evt.dataTransfer.effectAllowed = "move";
            evt.dataTransfer.setData("itemIndex", draggedPointIndex);
        },
        onDrop(evt, droppedPointIndex) {
            this.newPayload = [];
            this.renderCount++;
            log("DAD drop point ", this.payload[droppedPointIndex].id);
            const draggedPointIndex = evt.dataTransfer.getData("itemIndex");
            const moveIndex = (arr, from, to) => {
                const item = arr[from];
                arr.splice(from, 1);
                arr.splice(to, 0, item);
                return arr;
            };
            this.newPayload = this.payload;
            this.payload = moveIndex(this.newPayload, draggedPointIndex, droppedPointIndex);

            log(
                "payload after DAD",
                this.payload.map((x) => x.id)
            );
        },
    },
    mounted() {
        log("payload", this.payload);
    },
    watch: {
        payload: {
            deep: true,
            handler(nV, oV) {
                this.$emit("input", this.payload);
            },
        },
    },
};
</script>

<style lang="scss">
#question-wrapper {
    display: flex;
    flex-direction: column;

    .question-text-area {
        border-radius: 8px;
        background: #dbe1e8;
        height: 70px !important;
    }

    .success-or-failure {
        margin: 10px;
        padding: 13px;
        border-radius: 10px;
        width: 100%;
    }

    .drop-down-block-menu {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        margin: 10px;
    }

    .add-single-question-wrapper {
        align-items: center;
        display: flex;
        height: 40px;
        justify-content: center;
        width: 100%;

        &:before {
            border-top: 1px solid #494a5463;
            content: "";
            flex-grow: 1;
            height: 0;
            width: 0;
        }

        &:after {
            border-top: 1px solid #494a5463;
            content: "";
            flex-grow: 1;
            height: 0;
            width: 0;
        }

        .add-single-question {
            cursor: pointer;
            display: flex;
            margin: 0 10px;
            transition: opacity 0.3s;

            .add-single-question-plus {
                align-items: center;
                background: #fff;
                border-radius: 100%;
                box-shadow: 0 1px 4px 0 rgb(0 0 0 / 19%);
                display: flex;
                height: 22px;
                justify-content: center;
                margin-right: 10px;
                transition: background-color 0.3s;
                width: 22px;

                &:hover {
                    background-color: #006cff;
                    color: #fff;
                }
            }

            span.text {
                color: #475e7a;
                font-weight: 600;
            }
        }
    }
}
</style>
